import { useOptionalHangarState } from "../containers/HangarStateContainer";
import { useMultiHangarState } from "../containers/MultiHangarContainer";

export const useThisHangar = () => {
  const singleHangarState = useOptionalHangarState();
  const multiHangarState = useMultiHangarState();
  if (multiHangarState?.isMultiHangar) {
    return multiHangarState;
  }
  return singleHangarState || { hangar: undefined, getHangar: () => undefined, setHangar: () => {}, history: undefined, isReference: false };
};
